module.exports = __webpack_public_path__ + "img/qx80-25.00b97cdb.png";